module.exports = __webpack_public_path__ + "static/media/Colette Queen Bed Base - 155x205 cm_Dark Brown.8de03a3c.png";